<template>
  <div class="col-md-12 mt-5">
    <h4 class="text-center">Partos</h4>
    <v-divider></v-divider>
    <div class="col-md-12 mt-5" v-if="computedConsultations.length">
      <v-expansion-panels 
        v-model="order"
        :readonly="true"
      >
        <v-expansion-panel 
          v-for="(item, idx) in computedConsultations" 
          :key="item.birth.id" 
          class="my-5"
        >
          <v-expansion-panel-header>
            <div class="d-flex justify-content-between">
              <div class="mx-1">
                <h6>Dt Parto:</h6>
                <date-picker 
                  :binding.sync="item.birth.date"
                />
              </div>
              <div class="mx-1">
                <h6>Tp do Parto:</h6>
                <v-select 
                  :items="kinds_birth" 
                  item-text="name"
                  item-value="name"
                  v-model="item.birth.kind_birth"
                  outlined
                />
              </div>
              <div class="mx-1">
                <h6>Tp Encerramento:</h6>
                <v-select 
                  :items="closure_reasons.map(e => ({...e, id:e.id.toString()}))"
                  item-text="name"
                  item-value="id"
                  v-model="item.birth.explanation_kind" 
                  outlined
                />
              </div>
              <div class="mx-1">
                <h6>Dt Encerramento:</h6>
                <date-picker 
                  :binding.sync="item.birth.explanation_date"
                  @change="checkExplanationDate(item)"
                />
              </div>
              <div class="mx-1 d-flex align-items-center">
                <v-btn 
                  @click="updateBirth(item.birth)"
                  class="success"
                >Salvar</v-btn>
              </div>
            </div>
            <template #actions>
              <!-- I2: cada chevron abre a própria lactação (antes todos abriam só a 1ª) -->
              <i 
                v-if="order !== idx" 
                class="mdi mdi-chevron-down icon"
                @click.prevent="order = idx"
              ></i>
              <i 
                v-if="order === idx" 
                class="mdi mdi-chevron-up icon" 
                @click.prevent="order = undefined"
              ></i>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content v-if="item.services.length">
            <div v-for="service in item.services" :key="service.id" class="d-flex justify-content-between mr-6 my-8">
              <div class="mx-1">
                <h6>Serviço</h6>
              <span class="service-index">#{{service.i}}</span>
              </div>
              <div class="mx-1">
                <h6>Dt Serviço</h6>
                <date-picker 
                  :binding.sync="service.date"
                  disabled
                />
              </div>
              <div class="mx-1">
                <h6>Esgota</h6>
                <v-text-field 
                  v-model="service.exhaustion"
                  outlined 
                />
              </div>
              <div class="mx-1">
                <h6>1º Ordenha</h6>
                <v-text-field 
                  v-model="service.first_weight"
                  outlined 
                />
              </div>
              <div class="mx-1">
                <h6>2º Ordenha</h6>
                <v-text-field 
                  outlined 
                  v-model="service.second_weight"
                />
              </div>
              <div class="mx-1">
                <h6>3º Ordenha</h6>
                <v-text-field 
                  v-model="service.third_weight"
                  outlined 
                />
              </div>
              <div class="mx-1">
                <h6>Explicação</h6>
                <span 
                style="max-width:50px"
                v-if="!service.lactation.filter(e => e === '10' || e === '38').length"
              >
                <v-autocomplete
                  outlined
                  multiple
                  label=""
                  :items="explanations"
                  item-text="title"
                  item-value="id"
                  v-model="service.lactation"
                  no-data-text="Nenhum resultado..."
                  style="max-width:100px"
                ></v-autocomplete>
              </span>
              <span 
                v-else
              >
                <v-autocomplete
                  outlined
                  multiple
                  :items="explanations.filter(e => e.id === '10' || e.id === '38')"
                  item-text="title"
                  item-value="id"
                  v-model="service.lactation"
                  no-data-text="Nenhum resultado..."
                  style="max-width:100px"
                ></v-autocomplete>
              </span>
              </div>
              <div class="mx-1 d-flex flex-column align-items-center">
                <v-btn 
                  class="success my-2"
                  @click="
                    showConfirmationService = true,
                    serviceToUpdate = service
                  "
                >
                  Salvar
                </v-btn>
                <v-btn 
                  class="error my-2"
                  @click="
                    showConfirmationServiceDelete = true,
                    serviceToDelete = service
                  "
                >
                  Deletar
                </v-btn>
              </div>
            </div>
          </v-expansion-panel-content>
          <v-expansion-panel-content
            v-else
          >
            <p class="m-0 text-center">Nenhum serviço encontrado ...</p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div v-else class="col-md-12 mt-5">
      <p class="m-0 text-center">Nenhum item encontrado ...</p>
    </div>

    <alert-modal 
      :active="showConfirmationService"
      @close="showConfirmationService = false"
      @save="updateService"
    />

    <alert-modal-service-delete 
      :active="showConfirmationServiceDelete"
      @close="showConfirmationServiceDelete = false"
      @save="deleteService"
    />
  </div>
</template>

<script>
import DatePicker from "@/components/layout/DatePicker";
import AlertModal from "./AlertModal.vue";
import AlertModalServiceDelete from "./AlertModalServiceDelete.vue";
import {mapActions, mapState} from "vuex";
export default {
  name:"BirthsList",
  components: {
    DatePicker,
    AlertModal,
    AlertModalServiceDelete
  },
  data() {
    return {
      consultationsList:[],
      showConfirmationService:false,
      serviceToUpdate:{},
      serviceToDelete:{},
      showConfirmationServiceDelete:false,
      order:undefined,
      originalList:[]
    }
  },
  computed: {
    ...mapState("birth_consultation", [
      "birthsConsultations",
    ]),
    ...mapState("animals", [
      "kinds_birth",
      "explanations",
      "closure_reasons"
    ]),
    computedConsultations: {
      get() {
        if(this.consultationsList.births) {
          return this.consultationsList.births;
        } else {
          return [];
        }
      },
      set(newValue) {
        this.consultationsList.births = newValue;
      }
    }
  },
  methods: {
    ...mapActions("animals", [
      "actionGetRegimes",
    ]),
    ...mapActions("birth_consultation", [
      "actionUpdateBirth",
      "actionUpdateService",
      "actionDeleteService"
    ]),
    async updateBirth(birth) {
      if(!birth.date || !birth.kind_birth) {
        this.$toast.error("Data do parto e Tipo de parto são obrigatórios");
        return;
      }
      const payload = {...birth};
      payload.end_at = !payload.explanation_date ? "-" : payload.explanation_date;
      payload.end_production_reasons = payload.explanation_kind;
      delete payload.explanation_kind;
      delete payload.explanation_date;
      try {
        await this.actionUpdateBirth(payload);
        this.$toast.success("Parto atualizado com sucesso !");
      } catch(error) {
        this.$toast.error(error);
      }
    },
    updatedStorage(oldItem, itemToUpdate) {
      const updated = [];
      oldItem.births.forEach(e => {
        if(e.birth.id && itemToUpdate.birth.id) {
          e = itemToUpdate;
        }
        updated.push(e);
      });
      localStorage.setItem("birth-consultation-list", JSON.stringify({...oldItem, births:updated}));
    },
    checkExplanationDate(item) {
      const oldList = JSON.parse(localStorage.getItem("birth-consultation-list"));
      const oldItem = oldList.births.find(old => old.birth.id === item.birth.id);
      switch(true) {
        case (oldItem.birth.explanation_date === "" && item.birth.explanation_date !== ""):
          this.computedConsultations.forEach(birthCon => {
            birthCon.birth.verified = "insert";
          });
          break;
        case (oldItem.birth.explanation_date !== "" && item.birth.explanation_date === null) :
          this.computedConsultations.forEach(birthCon => {
            birthCon.birth.verified = "clear";
          });
          break;
        case (
          oldItem.birth.explanation_date?.length && 
          item.birth.explanation_date?.length && 
          oldItem.birth.explanation_date !== item.birth.explanation_date
        ) :
          this.computedConsultations.forEach(birthCon => {
            birthCon.birth.verified = "change";
          });
          break;
      }
      this.updatedStorage(oldList, item);
    },
    async updateService() {
      try {
        const payload = {
          id:this.serviceToUpdate.id,
          service_animal: {
            exhaustion:this.serviceToUpdate.exhaustion,
            first_weight:this.serviceToUpdate.first_weight,
            second_weight:this.serviceToUpdate.second_weight,
            third_weight:this.serviceToUpdate.third_weight,
            lactation:this.serviceToUpdate.lactation,
          }
        }
        await this.actionUpdateService(payload);
        this.$toast.success("Serviço atualizado com sucesso !");
        this.showConfirmationService = false;
      } catch(error) {
        this.$toast.error(error);
      }
    },
    async deleteService() {
      try {
        await this.actionDeleteService(this.serviceToDelete);
        this.$toast.success("Animal retirado do serviço com sucesso !");
        let index = -1;
        let indexBirth = -1;
        this.computedConsultations.forEach((e, i) => {
          index = e.services.findIndex(serv => serv.id === this.serviceToDelete.id);
          if(index !== -1) {
            indexBirth = i;
          }
        })
        this.computedConsultations.forEach((item, index) => {
          if(index === indexBirth) {
            item.services.splice(index, 1);
          }
        })
        this.showConfirmationServiceDelete = false;
      } catch(error) {
        this.$toast.error(error);
      }
    }
  },
  watch: {
    birthsConsultations(val) {
      if(Object.values(val).length) {
        this.consultationsList = val;
        localStorage.setItem("birth-consultation-list", JSON.stringify(val));
      }
    }
  },
  async mounted() {
    await this.actionGetRegimes();
  }
}
</script>

<style scoped>
  .v-btn {
    max-width: 70px;
    font-size: 0.8rem;
  }
  .service-index {
    font-size: 1rem;
    padding-top: 30px;
  }
  .icon {
    font-size: 1.4rem;
  }
</style>